import { useState } from 'react';
import { Button } from 'react-bootstrap';

import { fetchDataAuthenticated } from '../../../utilities/HttpUtils'
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

const SampleManagerApiHealthCheck = () => {
    const { setAlert } = useAlert();
    const [healthCheck, setHealthCheck] = useState();
    const [variant, setVariant] = useState();

    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;

    const getHealthCheck = () => {
        fetchDataAuthenticated(_apiUrl + "api/diagnostic/smapi/health", "GET")
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                setVariant("");
                let healthCheckResponse = "Succesful Health Check";
                setAlert("success", "Succesful", healthCheckResponse);
                setHealthCheck(healthCheckResponse);
            })
            .catch(error => {
                setAlert("danger", error.title, error.detail);
                setHealthCheck(error.detail);
                setVariant("danger");
            });
    }

    function SMHealthCheck() {
        return (
            <>
                <Button className="mt-2" onClick={getHealthCheck}>Health Check</Button>
                {healthCheck &&
                    <div className="mt-1 mb-2">
                        {healthCheck}
                    </div>}
            </>
        );
    }

    return (
        <AdminTile
            title={"SM-API Health Check"}
            description={"Get health information from sample manager api"}
            variant={variant}>
            <SMHealthCheck />
        </AdminTile>
    );
}

export default SampleManagerApiHealthCheck;